/** Which series a sparkline belongs to. `brand` is the only tone that may use the accent. */
export type SparklineTone = 'brand' | 'neutral' | 'violet'

/** Full literal stroke classes, so Tailwind's scanner sees them. Never build these by concatenation. */
export const SPARKLINE_STROKE: Record<SparklineTone, string> = {
  brand: 'stroke-accent-blue',
  neutral: 'stroke-series-rival',
  violet: 'stroke-accent-violet',
}

/** Fill classes for the end dot, paired with {@link SPARKLINE_STROKE}. */
export const SPARKLINE_FILL: Record<SparklineTone, string> = {
  brand: 'fill-accent-blue',
  neutral: 'fill-series-rival',
  violet: 'fill-accent-violet',
}
